
<template>
  <div v-if="entry">

    <div class='clpp-api-name clpp-api-title clpp-api-title-primary'>
      {{entry.longname}}
    </div>

    <div v-if="entry.experimental" class="experimental-warning">
      This API is experimental and may change in future patch versions.
    </div>

    <div class='clpp-api-description class-description' v-html="description">
      {{description}}
    </div>

    <div v-if='entry.kind === "namespace"' class="clpp-api-element">
      <h2>Overview</h2>
      <div class='clpp-api-level' v-if='staticMethods.length'>
        <h3>Static methods</h3>
        <DocsOverviewEntry v-for='e in staticMethods' :key="e.___id" :entry='e'/>
      </div>
      <div class='clpp-api-level' v-if='methods.length'>
        <h3>Methods</h3>
        <DocsOverviewEntry v-for='e in methods' :key="e.___id" :entry='e'/>
      </div>

      <div class='clpp-api-level' v-if='events.length'>
        <h3>Events</h3>
        <DocsOverviewEntry v-for='e in events' :key="e.___id" :entry='e'/>
      </div>

      <div class='clpp-api-level' v-if='types.length'>
        <h3>Types</h3>
        <DocsOverviewEntry v-for='e in types' :key="e.___id" :entry='e'/>
      </div>

      <div class='clpp-api-level' v-if='namespaces.length'>
        <h3>Namespaces</h3>
        <DocsOverviewEntry v-for='e in namespaces' :key="e.___id" :entry='e'/>
      </div>

      <div class='clpp-api-level' v-if='staticProperties.length'>
        <h3>Properties and Constants</h3>
        <DocsOverviewEntry v-for='e in staticProperties' :key="e.___id" :entry='e'/>
      </div>

      <div class='clpp-api-level' v-if='classes.length'>
        <h3>Classes</h3>
        <DocsOverviewEntry v-for='e in classes' :key="e.___id" :entry='e'/>
      </div>
    </div>

    <div v-if='entry.kind === "namespace"'>
      <div v-if='methods.length' class="clpp-api-element">
        <h2>Methods</h2>
        <div v-for='e in methods' :key="'m'+e.___id">
          <DocsDetailFunction  :id='e.name' :entry='e'/>
        </div>
      </div>

      <div v-if='events.length' class="clpp-api-element">
        <h2>Events</h2>
        <div v-for='e in events' :key="'m'+e.___id">
          <DocsDetailEvent  :id='e.name' :entry='e' class="clpp-api-element clpp-api-level"/>
        </div>
      </div>

      <div v-if='staticMethods.length' class="clpp-api-element">
        <h2>Static Methods</h2>
        <div v-for='e in staticMethods' :key="'m'+e.___id">
          <DocsDetailFunction  :id='e.name' :entry='e' class="clpp-api-element clpp-api-level"/>
        </div>
      </div>

      <div v-if='types.length' class="clpp-api-element">
        <h2>Types</h2>
        <div v-for='e in types' :key="'m'+e.___id" >
          <DocsDetailType :id='e.name' :entry='e' class="clpp-api-element clpp-api-level"/>
        </div>
      </div>

      <div v-if='staticProperties.length' class="clpp-api-element">
        <h2>Properties and Constants</h2>
        <div v-for='e in staticProperties' :key="'m'+e.___id" class="clpp-api-element clpp-api-level">
          <DocsDetailType :id='e.name' :entry='e'/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';
import DocsOverviewEntry from './DocsOverviewEntry.vue';
import DocsDetailFunction from './DocsDetailFunction.vue';
import DocsDetailType from './DocsDetailType.vue';
import DocsDetailEvent from './DocsDetailEvent.vue';

export default {
  mixins: [DocsComponentMixin],

  name: 'DocsDetailNamespace',
  components: {
    DocsOverviewEntry,
    DocsDetailFunction,
    DocsDetailType,
    DocsDetailEvent
  },
  data () {
    return {
      needsToScroll: null
    };
  },
  created () {
    this.needsToScroll = this.$route.hash;
  },
  mounted () {
    if (this.needsToScroll) {
      const el = document.getElementById(this.needsToScroll.substr(1));
      if (el) {
        el.scrollIntoView(true);
        this.needsToScroll = false;
      }
    }
  }

};
</script>
